import type { ObjectId } from '@freightview/object-id'

import {
  vArray,
  vBoolean,
  vNonEmptyString,
  vNumber,
  vObject,
  vOptional,
  type vOutput,
  vPicklist,
  vString,
} from '../validation/index.ts'
import type { Workflow } from './common.ts'
import { workflows } from './common.ts'

export interface LoadUpload {
  _id: ObjectId
  accountId: ObjectId
  userId: ObjectId
  adminUserId?: ObjectId
  workflow: Workflow
  name: string
  createdDate: Date
  archivedDate?: Date
  completedDate?: Date
  loadCount?: number
  completedCount?: number
}

export const loadUploadCreateSchema = vObject({
  name: vNonEmptyString(),
  workflow: vPicklist(workflows),
  loadCount: vNumber(),
})
export type LoadUploadCreateDto = vOutput<typeof loadUploadCreateSchema>

export interface LoadUploadQuotePreference {
  carrierId?: ObjectId
  cheapest?: boolean
}
export interface LoadUploadReference {
  _id: ObjectId
  quotePreference?: LoadUploadQuotePreference
}

export const loadUploadArchiveSchema = vObject({
  discardUnbookedLoads: vOptional(vBoolean()),
})
export type LoadUploadArchiveDto = vOutput<typeof loadUploadArchiveSchema>

export type ShipmentUploadError = {
  message: string
  row?: number
  column?: string
  allowedValues?: string[]
}

export type ShipmentsUploadResponse = {
  errors: ShipmentUploadError[]
  uploadId?: ObjectId
}

export const uploadQuoteSelectionSchema = vObject({
  loadId: vString(),
  quoteId: vString(),
})
export type UploadQuoteSelection = vOutput<typeof uploadQuoteSelectionSchema>

export const bulkBookLoadsSchema = vObject({
  selections: vArray(uploadQuoteSelectionSchema),
})
export type BulkBookLoadsDto = vOutput<typeof bulkBookLoadsSchema>

export type BulkBookLoadError = {
  loadId: string
  quoteId: string
  message: string
}

export type BulkBookLoadsResult = {
  loadIds: string[]
  errors: BulkBookLoadError[]
}
